import React from 'react';
import { useTranslation } from 'react-i18next';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const Pdf = ({ pdf, fileName, transferLiability, clientName, ref }) => {
    const { t } = useTranslation();
    const heading = transferLiability ?
        <>
            <h5>{t("infotextpayment")}</h5>
            <p>{t("infotextoblieged").replace('{0}', clientName)}</p>
        </> :
        <>
            <h5>{t("infotexttopay")}</h5>
            <p>{t("infoidentificationnrtopay")}</p>
        </>;

    const base64PdfString = pdf;

    const downloadPDF = () => {
        const byteCharacters = atob(base64PdfString);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <>
            <div className='result-pdf' ref={ref} style={{ minHeight: 1140 + 'px' }} >
                <div className='result-pdf-heading'>
                    {heading}
                </div>

                <div className="result-pdf-body" style={{ minHeight: 1050 + 'px' }}>
                    <button className="pdf-download" onClick={downloadPDF}>
                        <svg style={{ width: 24 + 'px' }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2c-.55 0-1 .45-1 1v8.922a10 10 0 0 0 .254 2.24l-.206.206-.215-.344c-.4-.64-.873-1.234-1.407-1.768l-.966-.966a.996.996 0 0 0-1.41 0c-.39.39-.39 1.03 0 1.42l3.89 3.883a1.5 1.5 0 0 0 2.12 0l3.89-3.883c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-.966.966a10.004 10.004 0 0 0-1.407 1.768l-.215.344-.206-.207a10 10 0 0 0 .254-2.24V3c0-.55-.45-1-1-1zM6 20a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H6z" fill="#000000"></path></g></svg>
                        {t("download")} PDF
                    </button>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                        <Viewer fileUrl={`data:application/pdf;base64,${base64PdfString}`} />
                    </Worker>
                </div>
            </div>
        </>
    );
};

export default Pdf


